import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const createWaterWavesOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.waterwaves.full_calm', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.waterwaves.weak', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.waterwaves.moderate', value: '3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.waterwaves.high_waves', value: '4' }),
];

type CreateWaterWavesFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createWaterWavesSportsFilters = ({
  searchParams,
  translationDictionary,
}: CreateWaterWavesFilters): Filter[] => {
  const showEntertainmentFilter = isBeachHoliday(searchParams);
  const selectedValues = searchParams[URLParameters.WATER_WAVES]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const waterWavesFilter: Filter | undefined = showEntertainmentFilter
    ? {
        name: FILTER_NAME.WATER_WAVES,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createWaterWavesOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[waterWavesFilter]].filter((f) => !!f);
};
